import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'portal-logo-svg',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoSvgComponent {
  public altText = input<string>();
  public className = input<string>();
  public link = 'assets/images/logo.svg';
}
